import stagingLogo from '@/assets/staging-logo.svg';
import demoLogo from '@/assets/af-control-logo.svg';
import betwinnerLogo from '@/assets/logo.svg';
import sprutLogo from '@/assets/sprut-logo.png';
import casinozLogo from '@/assets/casinoz-logo.svg';
import marathonLogo from '@/assets/marathon-logo.svg';
import betpariLogo from '@/assets/betpari-logo.svg';
import speletLogo from '@/assets/spelet-logo.svg';
import caswinoLogo from '@/assets/caswino-logo.svg';
import winonLogo from '@/assets/winon-logo.svg';
import goodPartnersLogo from '@/assets/good-logo.svg';
import fairPariLogo from '@/assets/fairpari-logo.svg';
import funPariLogo from '@/assets/funpari-logo.svg';
import apuesta360Logo from '@/assets/apuesta360-logo.svg';


export function getPageTitle(customerId) {
  switch (customerId) {
    case 'test':
      return 'StagingAffiliates';

    case 'betwinner':
      return 'BetWinnerAffiliates';

    case 'sprut':
      return 'SprutPartners';

    case 'casinoz':
      return 'SpinBetter';

    case 'marathonbet':
    case 'mbetru' :
      return 'MarathonBet Partners';

    case 'betpari':
      return 'BetPari Partners';
    case 'spelet':
      return 'Spelet Partners';

    case 'winon':
      return 'GORoll Partners';

    case 'caswino':
      return 'Caswino Partners';

    case 'goodpartners':
      return 'Grandpari Partners';

    case 'funpari':
      return 'FunPari Partners';

    case 'fairpari':
      return 'FairPari Partners';

    case 'apuesta360':
      return 'Apuesta360 Partners';

    case 'demo':
    default:
      return 'AffiliateControl';
  }
}

export function getHomepageDomain(customerId) {
  switch (customerId) {
    case 'test':
      return 'affctrltest.com';

    case 'betwinner':
      return 'betwinneraffiliates.com';

    case 'sprut':
      return 'sprutpartners.com';

    case 'casinoz':
      return 'spinbet.partners';

    case 'marathonbet':
    case 'mbetru':
      return 'marathonbet.partners';

    case 'betpari':
      return 'betpari.partners';

    case 'spelet':
      return 'spelet.partners';

    case 'winon':
      return 'winon.partners';

    case 'caswino':
      return 'caswino.partners';

    case 'goodpartners':
      return 'goodpartners.partners';

    case 'funpari':
      return 'funpari.partners';

    case 'fairpari':
      return 'fairpari.partners';

    case 'apuesta360':
      return 'apuesta360.partners';

    case 'demo':
    default:
      return 'affiliatecontroldemo.com';
  }
}

export function getLogo(customerId) {
  switch (customerId) {
    case 'test':
      return stagingLogo;

    case 'betwinner':
      return betwinnerLogo;

    case 'sprut':
      return sprutLogo;

    case 'casinoz':
      return casinozLogo;

    case 'marathonbet':
    case 'mbetru':
      return  marathonLogo;

    case 'betpari':
      return  betpariLogo;

    case 'spelet':
      return  speletLogo;

     case 'caswino':
      return  caswinoLogo;

    case 'winon':
      return  winonLogo;

    case 'goodpartners':
      return goodPartnersLogo;

    case 'funpari':
      return funPariLogo;

    case 'fairpari':
      return fairPariLogo;

    case 'apuesta360':
      return apuesta360Logo;

    case 'demo':
    default:
      return demoLogo;
  }
}

export function getTheme(customerId) {
  switch (customerId) {
    case 'test':
      return 'test';

    case 'betwinner':
      return 'betwinner';

    case 'sprut':
      return 'sprut';

    case 'casinoz':
      return 'casinoz';

    case 'marathonbet':
      return  'marathonbet';

    case 'mbetru':
      return  'mbetru';

    case 'betpari':
      return  'betpari';

    case 'spelet':
      return  'spelet';

    case 'caswino':
      return 'caswino';

    case 'winon':
      return 'winon';

    case 'goodpartners':
      return 'goodpartners';

    case 'funpari':
      return 'funpari';

    case 'fairpari':
      return 'fairpari';

    case 'apuesta360':
      return 'apuesta360';

    case 'demo':
    default:
      return 'demo';
  }
}
